export default __webpack_public_path__ + "static/media/2_file_upload.c84705b3.svg";